export const BLOCK_TYPE_OPTIONS = {
  DEFAULT: 'DEFAULT',
  PREREQ: 'PREREQ',
  RECAP: 'RECAP',
  GOAL: 'GOAL',
  TESTS: 'TESTS',
  PLAYLIST: 'PLAYLIST',
  SOLUTIONS: 'SOLUTIONS',
  NOTES: 'NOTES',
  FLASHCARDS: 'FLASHCARDS',
  SUBJECTIVES: 'SUBJECTIVES',
  PUZZLE_CARDS: 'PUZZLE_CARDS',
  SAT_MOCK_TEST: 'SAT_MOCK_TEST',
};

export const SECTION_CODE_OPTIONS = {
  READINESS: 'READINESS',
  GOALS: 'GOALS',
  TESTS: 'TESTS',
  ENRICHMENT: 'ENRICHMENT',
  SUBJECTIVE: 'SUBJECTIVE',
  VIDEOS: 'VIDEOS',
  NOTES: 'NOTES',
  FLASHCARDS: 'FLASHCARDS',
  PUZZLE_CARDS: 'PUZZLE_CARDS',
};

export const TAB_CODE_OPTIONS = {
  MASTERY: 'MASTERY',
  LEARNING_VIDEOS: 'LEARNING_VIDEOS',
  STUDY_MATERIAL: 'STUDY_MATERIAL',
  REVISION_MATERIAL: 'REVISION_MATERIAL',
  BOOK_SOLUTIONS: 'BOOK_SOLUTIONS',
  PUZZLE_CARDS: 'PUZZLE_CARDS',
};
